import { useState } from 'react';
import { Link } from 'react-router-dom';

import { MenuItem, Menu } from '@mui/material';

export default function RestoEditMenu({ restoId, claimStatus, isEnhanced }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        id='basic-button'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className='cursor-pointer'
      >
        <div className='whitespace-nowrap'>
          <i className='fas fa-circle scale-25 text-gray-500'></i>
          <i className='fas fa-circle scale-25 text-gray-500 -ml-1'></i>
          <i className='fas fa-circle scale-25 text-gray-500 -ml-1'></i>
        </div>
      </div>
      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Link to={`/restaurants/${restoId}/edit`}>
          <MenuItem onClick={handleClose}>Edit Listing</MenuItem>
        </Link>
        {claimStatus !== 'claimed' && (
          <a
            href='https://form.jotform.com/222286439067159'
            className='text-xs'
            target='_blank'
            rel='noreferrer'
          >
            <MenuItem onClick={handleClose}>Claim Listing</MenuItem>
          </a>
        )}
        {!isEnhanced && (
          <Link to={`/restaurants/${restoId}/subscribe`}>
            <MenuItem onClick={handleClose}> Upgrade Listing</MenuItem>
          </Link>
        )}
      </Menu>
    </>
  );
}
